import React, { useMemo } from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getSeverity } from '../../../../../Analysis/sca-dds-kyc-widgets/table-components/helper';
import { truncate } from 'lodash';

const Style = styled.div`
  display: flex;
  gap: 20px;
  padding: 23px 26px;

  .cont {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: fit-content;
    gap: 20px;

    .group {
      display: flex;
      flex-direction: column;

      label {
        font-weight: 600;
        font-size: 14px;
      }

      .tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .ant-tag {
          margin-right: 0px;
        }
      }
    }
  }
`;

export default function ExpandedRowEvent({
  event = {},
}) {
  const { t } = useTranslation();

  const renderedTags = useMemo(() => {
    if (Array.isArray(event.category) && event.category.length) {
      return event.category.map((cat) => (
        <div key={cat.value}>
          <Tag>{cat.label}</Tag>
        </div>
      ));
    }
    return <Tag>{t('Unavailable')}</Tag>;
  }, [event, t]);

  const renderDocuments = useMemo(() => {
    const docs = (event.documents || []).map(d => {
      if (event.linking && event.linking.Documents && event.linking.Documents[d.documentId]) {
        return event.linking.Documents[d.documentId];
      }
      return undefined;
    }).filter(d => d).reduce((a, b) => {
      if (b.type === 'picture' && Array.isArray(b.pictures) && b.pictures.length) {
        a = a.concat(b.pictures.map(p => {
          p.title = b.title;
          return p;
        }))
      }
      if (b.type !== 'picture' && Array.isArray(b.documents) && b.documents.length) {
        a = a.concat(b.documents.map(p => {
          p.title = b.title || p.name;
          return p;
        }))
      }
      return a;
    }, []);
    if (docs.length) {
      return docs.map((d) => (
        <div key={d.id}>
          <a href={d.url} target="_blank" rel="noreferrer">
            <Tag style={{ width: '100%' }}>{d.title || truncate(d.url, { length: 50})}</Tag>
          </a>
        </div>
      ));
    }
    return <Tag>{t('Unavailable')}</Tag>;
  }, [event, t]);
  return (
    <Style>
      <div className="cont">
        {event.severity && (
          <div className="group">
            <label>{t('Severity of Incident')}</label>
            {getSeverity({ t, type: 'moderate' })}
          </div>
        )}
        <div className="group">
          <label>{t('Associated risk type(s)')}</label>
          <div className="tags">
            {renderedTags}
          </div>
        </div>
        <div className="group">
          <label>{t('Documents')}</label>
          <div className="tags">
            {renderDocuments}
          </div>
        </div>
      </div>
      <div className="cont">
        <div className="group">
          <label>{t('Event description')}</label>
          <p>
            {event.description || t('Unavailable')}
          </p>
        </div>
      </div>
    </Style>
  );
}
